import { lazy } from "react"
import { homeRoutes } from "etl/types";

const HomeTemplate = lazy(() =>
	import("etl/design-system/templates/Home").then(({ Home }) => ({
		default: Home,
	}))
)

export const EtlHomeRouter = [
	{
		path: homeRoutes.home.path,
		component: <HomeTemplate />,
	},
];
